import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useTranslation } from 'react-i18next';
import classes from './CardWithStatus.module.scss';
import { timesheetsStatuses } from '../../../../../utils/constants';
import colors from '../../../../../scss/colors';

export default function CardWithStatus(props) {
  const { status, clickHandler, isApprover, isVisited, children } = props;

  const { t } = useTranslation();

  let rowClass = classes.innerContainer; // Default class

  if (isApprover) {
    rowClass = classes.innerContainerApprover;
  } else if (isVisited === false) {
    rowClass = `${classes.innerContainer} ${classes.highlightRow}`;
  }

  return (
    <div
      role="presentation"
      data-testid="cardwithstatus"
      onClick={clickHandler}
      className={classes.outerContainer}
      style={{ backgroundColor: timesheetsStatuses(t)[status]?.color || colors.WHITE }}
    >
      <div className={rowClass}>
        {children}
        <ArrowForwardIosIcon sx={{ color: colors.NAVY_BLUE, opacity: '0.1' }} />
      </div>
    </div>
  );
}
